var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Inject, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CONFIGURE_PROJECT_LOADING_HANDLERS } from './core/hook/configure-project-loading-handler';
import { ConfigureViewType } from './designer/shared/configure-view-type';
import { ConfigureOwnerType } from './shared/configure.type';
import { ConfigureSimulationComponent } from './simulation/configure-simulation.component';
import { appModuleAnimation } from './animations/routerTransition';
import { ConfigureComponentBase } from '../../shared/configure-component-base';
import { ReleaseConfigureDto, ReleaseViewDto, EntityDto } from '../../shared/service-proxies/service-proxies';
import { TabDirective } from 'ngx-bootstrap';
import * as _ from 'lodash';
export var ConfigureStatus;
(function (ConfigureStatus) {
    ConfigureStatus["NotStarted"] = "NotStarted";
    ConfigureStatus["Loading"] = "Loading";
    ConfigureStatus["Loaded"] = "Loaded";
    ConfigureStatus["Error"] = "Error";
})(ConfigureStatus || (ConfigureStatus = {}));
var DesignWorkshopComponent = /** @class */ (function (_super) {
    __extends(DesignWorkshopComponent, _super);
    function DesignWorkshopComponent(injector, activatedRoute, fBoxAccountSettingsServiceProxy, configureService, variableService, diagramCompileSerivce, loadingHandlers, projectInfo, bsModalService, configureReleaseService, deviceModelService, router) {
        var _this = _super.call(this, injector) || this;
        _this.activatedRoute = activatedRoute;
        _this.fBoxAccountSettingsServiceProxy = fBoxAccountSettingsServiceProxy;
        _this.configureService = configureService;
        _this.variableService = variableService;
        _this.diagramCompileSerivce = diagramCompileSerivce;
        _this.loadingHandlers = loadingHandlers;
        _this.projectInfo = projectInfo;
        _this.bsModalService = bsModalService;
        _this.configureReleaseService = configureReleaseService;
        _this.deviceModelService = deviceModelService;
        _this.router = router;
        _this.boxTypeName = '';
        _this.hideBack = false;
        _this.dataSourceLoaded = false;
        _this.returnButtonTitle = '';
        _this.ownerType = ConfigureOwnerType.DeviceModel;
        _this.status = ConfigureStatus.NotStarted;
        _this.currentConfigureViewType = ConfigureViewType.Web;
        _this.defaultActive = false;
        _this.getConfigureViewTypeCallback = function (viewType) {
            _this.currentConfigureViewType = viewType;
        };
        return _this;
    }
    DesignWorkshopComponent.prototype.GetReturnButtonTitle = function () {
        if (this.ownerType === ConfigureOwnerType.NonStandardDevice) {
            return this.lc('Return') + this.ls('Device', 'DeviceManage');
        }
        else {
            return this.lc('Return') + this.ls('Device', 'DeviceModel');
        }
    };
    DesignWorkshopComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.configureId = params['id'];
            _this.name = params['name'];
            _this.ownerType = +params['type'];
            _this.deviceId = params['deviceId'];
            _this.returnButtonTitle = _this.GetReturnButtonTitle();
            _this.hideBack = params['hide'] === 'true' ? true : false;
            document.title = _this.name;
            if (params['tabActive']) {
                _this.defaultActive = true;
            }
        });
        this.doLoad();
        this.releaseConfigureHandler = function () { return _this.tryReleaseConfigure(); };
        abp.event.on('designer.try-release', this.releaseConfigureHandler);
        abp.event.on('designer:configureViewType', this.getConfigureViewTypeCallback);
        this.checkTargetPermission();
        window.addEventListener('popstate', function () {
            location.reload();
        }, false);
    };
    // 暂时注释
    DesignWorkshopComponent.prototype.loadConfigureSettingsData = function (ev) {
        if (ev != null && !(ev instanceof TabDirective)) {
            return;
        }
        this.configureSettingsView.loadConfigureSettings();
        abp.event.trigger('designer:save', function () {
            abp.ui.clearBusy();
        });
    };
    DesignWorkshopComponent.prototype.setDataSourceLoaded = function (ev) {
        if (ev != null && !(ev instanceof TabDirective)) {
            return;
        }
        this.dataSourceLoaded = true;
        abp.event.trigger('designer:save', function () {
            abp.ui.clearBusy();
        });
    };
    DesignWorkshopComponent.prototype.loadConfigureDashBoardData = function () {
        abp.event.trigger('configureDashboard.dashboardResize');
    };
    DesignWorkshopComponent.prototype.checkTargetPermission = function () {
        var _this = this;
        if (this.configureId) {
            this.deviceModelService.configureDesignGranted(this.configureId).subscribe(function (result) {
                if (!result) {
                    _this.router.navigate(['/app/main/device-model']);
                }
            });
        }
    };
    DesignWorkshopComponent.prototype.doLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        abp.ui.setBusy();
                        this.status = ConfigureStatus.Loading;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        this.projectInfo.id = this.configureId;
                        return [4 /*yield*/, this.configureService.initialize(new EntityDto({ id: this.configureId })).toPromise()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(_.map(this.loadingHandlers, function (handler) { return handler.execute(_this.configureId); }))];
                    case 3:
                        _a.sent();
                        this.doLoaded();
                        this.status = ConfigureStatus.Loaded;
                        return [3 /*break*/, 6];
                    case 4:
                        e_1 = _a.sent();
                        abp.log.error('Load configure failed.' + e_1);
                        this.status = ConfigureStatus.Error;
                        return [3 /*break*/, 6];
                    case 5:
                        abp.ui.clearBusy();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    DesignWorkshopComponent.prototype.doLoaded = function () {
        var _this = this;
        this.alertCallback = function (e) {
            if (_this.designerComponent.hasViewModified) {
                var confirmationMessage = '\o/';
                (e || window.event).returnValue = (confirmationMessage);
                return confirmationMessage;
            }
            else {
                return; // 返回为空的话不弹出框
            }
        };
        window.addEventListener('beforeunload', this.alertCallback);
        $(document).click(function () {
            $('.screen-more').hide(300);
            $('.operations').hide(300);
        });
        this.keyDownCallback = function (event) {
            if (event.ctrlKey && event.keyCode === 83) {
                _this.saveWorkshop();
                event.preventDefault();
                return false;
            }
        };
        $(document).keydown(this.keyDownCallback);
        this.saveAndLeaveDesigner = function (url) {
            if (_this.designerComponent.hasViewModified) {
                _this.saveWorkshop();
            }
            window.location.href = url;
        };
        abp.event.on('leaveDesigner.save', this.saveAndLeaveDesigner);
    };
    DesignWorkshopComponent.prototype.ngOnDestroy = function () {
        if (this.alertCallback) {
            window.removeEventListener('beforeunload', this.alertCallback);
        }
        if (this.keyDownCallback) {
            $(document).off('keydown', this.keyDownCallback);
        }
        abp.event.off('leaveDesigner.save', this.saveAndLeaveDesigner);
        abp.event.off('designer.try-release', this.releaseConfigureHandler);
        abp.event.off('designer:configureViewType', this.getConfigureViewTypeCallback);
        window.removeEventListener('popstate', function () { });
    };
    DesignWorkshopComponent.prototype.tryLeaveWorkshop = function () {
        if (this.designerComponent.hasViewModified) {
            this.leaveWorkshopWarningModal.show();
        }
        else {
            this.leaveWorkshop();
        }
    };
    DesignWorkshopComponent.prototype.tryReleaseConfigure = function () {
        var _this = this;
        this.fBoxAccountSettingsServiceProxy.hasTenantFBoxAccount().subscribe(function (hasFBoxAccount) {
            if (hasFBoxAccount) {
                _this.saveAndReleaseConfigure();
            }
            else {
                _this.checkFBoxAccountIsConfigured();
            }
        });
    };
    DesignWorkshopComponent.prototype.saveAndLeaveWorkshop = function () {
        this.saveWorkshop();
        this.leaveWorkshop();
    };
    DesignWorkshopComponent.prototype.leaveWorkshop = function () {
        window.removeEventListener('beforeunload', this.alertCallback);
        if (this.ownerType === ConfigureOwnerType.NonStandardDevice) {
            this.navigateToNonStandardDevice();
        }
        else {
            this.navigateToDeviceModel();
        }
    };
    DesignWorkshopComponent.prototype.refresh = function () {
        window.location.reload();
    };
    DesignWorkshopComponent.prototype.saveWorkshop = function () {
        this.designerComponent.saveDiagram();
    };
    DesignWorkshopComponent.prototype.checkFBoxAccountIsConfigured = function () {
        this.fboxAccountWarningModal.showWaring();
    };
    DesignWorkshopComponent.prototype.navigateToDeviceModel = function () {
        window.location.href = '/app/main/device-model';
    };
    DesignWorkshopComponent.prototype.navigateToNonStandardDevice = function () {
        if (this.deviceId) {
            window.location.href = this.appRootUrl() + "app/main/device/details?id=" + this.deviceId;
            return;
        }
        window.location.href = this.appRootUrl() + "app/main/device";
    };
    DesignWorkshopComponent.prototype.saveAndReleaseConfigure = function () {
        var _this = this;
        this.configureReleaseService.getDeletedDataSources(this.configureId).subscribe(function (result) {
            var message;
            if (result.items.length) {
                var dataSources = result.items.map(function (d) { return d.name; }).join(',');
                message = _this.lc('DataSourceDeletedWarningMessage', dataSources, _this.appSession.fBoxAlias);
            }
            else {
                message = _this.lc('ConfigureReleaseWarningMessage');
            }
            abp.message.confirm(message, _this.lc('SureToRelease'), function (isConfirmed) {
                if (!isConfirmed) {
                    return;
                }
                abp.ui.setBusy();
                setTimeout(function () {
                    _this.designerComponent.saveDiagram(function () { return _this.releaseConfigure(); });
                }, 100);
            });
        });
    };
    DesignWorkshopComponent.prototype.releaseConfigure = function () {
        var _this = this;
        this.configureService.getConfigureViews(this.configureId).subscribe(function (result) {
            var views = result.items;
            _.each(views, function (view) {
                var model = JSON.parse(view.configure);
                if (model) {
                    _.forEach(model.nodeDataArray, function (node) {
                        if (node.category === 'ToggleView' && node.viewIndex !== null) {
                            var targetView = _.find(views, function (v) { return v.index === node.viewIndex; });
                            if (!targetView || (view.type === ConfigureViewType.PopView && view.type !== targetView.type)) {
                                delete node.viewIndex;
                            }
                        }
                    });
                }
                view.configure = JSON.stringify(model);
            });
            _this.variableService.getAllVariables(_this.configureId).subscribe(function (variables) {
                var releaseConfigureInput = new ReleaseConfigureDto();
                releaseConfigureInput.id = _this.configureId;
                releaseConfigureInput.views = new Array();
                _.each(views, function (view) {
                    if (view.configure) {
                        var svg = _this.diagramCompileSerivce.build(view.configure, view.width, view.height, variables.items);
                        var releasedView = new ReleaseViewDto();
                        releasedView.id = view.id;
                        releasedView.width = view.width;
                        releasedView.height = view.height;
                        releasedView.viewIndex = view.index;
                        releasedView.releasedView = svg;
                        releaseConfigureInput.views.push(releasedView);
                    }
                });
                _this.configureReleaseService.releaseConfigure(releaseConfigureInput)
                    .pipe(finalize(function () { return abp.ui.clearBusy(); }))
                    .subscribe(function () { return abp.message.success('', _this.lc('SuccessfullyPosted')); });
            });
        });
    };
    DesignWorkshopComponent.prototype.preview = function () {
        var _this = this;
        this.designerComponent.saveDiagram(function () {
            _this.doPreview();
        });
    };
    DesignWorkshopComponent.prototype.doPreview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var args, mainViewPromise, viewsPromise, variablesPromise, results, views, variables_1, simulateViews_1, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        args = {
                            configureId: this.configureId,
                            views: [],
                            mainViewIndex: 0,
                            mobileMainViewIndex: 0,
                            viewType: this.currentConfigureViewType,
                            variables: []
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        mainViewPromise = this.configureService.getMainViewIndex(this.configureId).toPromise();
                        viewsPromise = this.configureService.getConfigureViews(this.configureId).toPromise();
                        variablesPromise = this.variableService.getAllVariables(this.configureId).toPromise();
                        return [4 /*yield*/, Promise.all([mainViewPromise, viewsPromise, variablesPromise])];
                    case 2:
                        results = _a.sent();
                        args.mainViewIndex = results[0].mainViewIndex;
                        args.mobileMainViewIndex = results[0].mobileMainViewIndex;
                        views = results[1].items;
                        this.handleToConfigureViews(views);
                        variables_1 = results[2].items;
                        args.variables = variables_1;
                        simulateViews_1 = [];
                        _.each(views, function (view) {
                            if (view.configure) {
                                var svg = _this.diagramCompileSerivce.build(view.configure, view.width, view.height, variables_1);
                                var simulateView = {
                                    viewIndex: view.index,
                                    content: svg
                                };
                                simulateViews_1.push(simulateView);
                            }
                        });
                        args.views = simulateViews_1;
                        this.showConfigureSimulationModal(args);
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        abp.log.error('Do preview failed.' + e_2);
                        return [3 /*break*/, 5];
                    case 4:
                        abp.ui.clearBusy();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DesignWorkshopComponent.prototype.handleToConfigureViews = function (views) {
        _.each(views, function (view) {
            var model = JSON.parse(view.configure);
            if (model) {
                _.forEach(model.nodeDataArray, function (node) {
                    if (node.category === 'ToggleView' && node.viewIndex != null) {
                        var targetView = _.find(views, function (v) { return v.index === (node.viewIndex); });
                        if (!targetView || (view.type === ConfigureViewType.PopView && view.type !== targetView.type)) {
                            delete node.viewIndex;
                        }
                    }
                });
            }
            view.configure = JSON.stringify(model);
        });
    };
    DesignWorkshopComponent.prototype.showConfigureSimulationModal = function (args) {
        this.bsModalService.show(ConfigureSimulationComponent, {
            initialState: {
                args: args,
            },
            backdrop: 'static',
            class: 'configure-simulation-modal'
        });
        setTimeout(function () {
            $('.configure-simulation-modal').draggable({
                cursor: 'pointer',
                handle: '.modal-header'
            });
        }, 100);
    };
    __decorate([
        ViewChild('designerView', { static: false })
    ], DesignWorkshopComponent.prototype, "designerComponent", void 0);
    __decorate([
        ViewChild('variableView', { static: false })
    ], DesignWorkshopComponent.prototype, "variableComponent", void 0);
    __decorate([
        ViewChild('historyDataView', { static: false })
    ], DesignWorkshopComponent.prototype, "historyDataComponent", void 0);
    __decorate([
        ViewChild('alarmRegistrationView', { static: false })
    ], DesignWorkshopComponent.prototype, "alarmRegistrationComponent", void 0);
    __decorate([
        ViewChild('leaveWorkshopWarningModal', { static: false })
    ], DesignWorkshopComponent.prototype, "leaveWorkshopWarningModal", void 0);
    __decorate([
        ViewChild('fboxAccountWarningModal', { static: false })
    ], DesignWorkshopComponent.prototype, "fboxAccountWarningModal", void 0);
    __decorate([
        ViewChild('configureSettingsView', { static: false })
    ], DesignWorkshopComponent.prototype, "configureSettingsView", void 0);
    DesignWorkshopComponent = __decorate([
        Component({
            selector: 'design',
            template: "<div [ngSwitch]=\"status\" class=\"design-workshop\"> <div *ngSwitchCase=\"'Error'\" class=\"loadFailedContainer\"> <div class=\"loadFailed\"> <img [src]=\"appRootUrl() + 'assets/common/images/configure/loadfailed.png'\" /> <h4>{{lc('LoadFailed')}}</h4> <button type=\"button\" class=\"btn btn-primary\" (click)=\"refresh()\"> {{lc(\"Retry\")}} </button> <button type=\"button\" class=\"btn btn-secondary\" (click)=\"leaveWorkshop()\"> {{lc(\"Return\")}} </button> </div> </div> <div *ngSwitchCase=\"'Loaded'\"> <div class=\"workshop\"> <div class=\"backDeviceModels\" onselectstart=\"return false\"> <button class=\"btn bgFFF\" (click)=\"tryLeaveWorkshop()\" *ngIf=\"!hideBack\"> <i class=\"iconPng back fcloud-left-arrow\"></i> <a> <span class=\"btnPading\">{{returnButtonTitle}}</span>/ <span class=\"btnPading\">{{name}}</span> </a> </button> <button class=\"btn bgFFF\" *ngIf=\"hideBack\"> <a> <span class=\"btnPading\">{{name}}</span> </a> </button> </div> <div class=\"navRight\" onselectstart=\"return false\"> <div class=\"btn-group\"> <button class=\"btn bgFFF\" (click)=\"preview()\"> <i class=\"iconPng simulation fcloud-simulation\"></i> <a>{{lc('Simulate')}}</a> </button> <button class=\"btn bgFFF\" (click)=\"tryReleaseConfigure()\"> <i class=\"iconPng released fcloud-released\"></i> <a>{{lc('Publish')}}</a> </button> </div> </div> <tabset class=\"tabsHead design-tabsHead\"> <tab heading=\"{{lc('ConfigureDesign')}}\" onselectstart=\"return false\"> <designer #designerView [configureId]=\"configureId\">{{l('LoadWithThreeDot')}}</designer> </tab> <tab heading=\"{{lc('VariableDataSourceConfiguration')}}\"> <data-source-configuration [configureId]=\"configureId\"></data-source-configuration> </tab> <tab heading=\"{{lc('DataTableDesign')}}\" (selectTab)=\"setDataSourceLoaded($event)\"> <data-configuration *ngIf=\"dataSourceLoaded\" #dataDesigner [configureId]=\"configureId\"></data-configuration> </tab> <tab heading=\"{{lc('ConfigureSettings')}}\" (selectTab)=\"loadConfigureSettingsData($event)\" onselectstart=\"return false\"> <configure-settings #configureSettingsView [configureId]=\"configureId\"></configure-settings> </tab> </tabset> </div> <app-leave-workshop-warning #leaveWorkshopWarningModal [name]=\"name\" (onSave)=\"saveAndLeaveWorkshop()\" (onUnSave)=\"leaveWorkshop()\"></app-leave-workshop-warning> <fc-fbox-account-warning #fboxAccountWarningModal></fc-fbox-account-warning> </div> </div> ",
            styles: ["﻿.design-workshop{ @padding: 5px; .workshop { background-color: #266cba; .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input { top: 0; } } .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input { top: 0; } .footer { text-align: right; } .navRight { float: right; } .backDeviceModels { float: left; } .workshop { .btn.bgFFF { transition: inherit; background: transparent; box-shadow: none; font-size: 14px; font-weight: normal; color:#e3edfe; &:hover{ color: #FFFFFF; text-underline: none; } } .btn.bgFFF:hover { box-shadow: none; } .boxType { color: #b0c9f4; font-size: 14px; font-weight: normal; display: inline-block; vertical-align: middle; position: relative; right: -18px; } tab { background-color: #ffffff; } } .design-tabsHead { // tab font color .nav.nav-tabs { .nav-link { color: #fff; } } .color-picker{ position: relative !important; } } .iconPng { display: inline-block; float: left; height: 20px; position: relative; top: 7px; font-size: 18px; } .back:hover{ color: #FFFFFF; } .released { color: #FFFFFF; } .simulation { color: #FFFFFF; } .btnPading { padding: 5px; } .loadFailedContainer { position: absolute; width: 100%; height: 100%; display: flex; text-align: center; } .loadFailed { height: 300px; margin: auto; h4 { color: #666; font-size: 24px; margin: 30px 0 40px 0; } .btn { width: 80px; } } } .designer-input-wrap{ .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{ top: 0; } } .clearfix:before, .clearfix:after { display: table; content: \" \"; } .clearfix:after { clear: both; } .clearfix{ *zoom: 1; } "],
            animations: [appModuleAnimation()]
        }),
        __param(6, Inject(CONFIGURE_PROJECT_LOADING_HANDLERS))
    ], DesignWorkshopComponent);
    return DesignWorkshopComponent;
}(ConfigureComponentBase));
export { DesignWorkshopComponent };
